module.exports = __webpack_public_path__ + "assets/img/tempalte_box.0e276140.svg";